// removed by extract-text-webpack-plugin
module.exports = {"flow":"m2te"};


//////////////////
// WEBPACK FOOTER
// ./src/features/Flows/Flow/Flow.scss
// module id = xisf
// module chunks = 0